import React from 'react';

const TelegramSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='14'
      viewBox='0 0 15 14'
      fill='none'
      className={className}
      {...props}
    >
      <path
        d='M14.641 0.337209C14.479 0.186783 14.2759 0.0810288 14.054 0.0315754C13.832 -0.0178699 13.5997 -0.00910845 13.3827 0.0569068L0.860246 3.96513C0.628002 4.03398 0.422781 4.16569 0.270491 4.34361C0.118201 4.52153 0.0256818 4.73769 0.00461703 4.96478C-0.0164478 5.19188 0.0348832 5.41969 0.152131 5.61951C0.269387 5.81932 0.447286 5.98214 0.663378 6.08745L5.85897 8.49004L8.4268 13.3673C8.53003 13.5582 8.68795 13.7185 8.88294 13.8302C9.07792 13.9419 9.30235 14.0007 9.53097 14H9.61657C9.86145 13.9831 10.0952 13.8977 10.2875 13.7549C10.4799 13.6121 10.6219 13.4184 10.6951 13.1991L14.932 1.51448C15.0077 1.31261 15.0205 1.09478 14.969 0.886354C14.9174 0.677937 14.8037 0.4875 14.641 0.337209ZM1.39093 5.07032L12.3214 1.65864L6.2527 7.3368L1.39093 5.07032ZM9.59089 12.7346L7.16 8.18572L13.2287 2.50755L9.59089 12.7346Z'
        fill='black'
      />
    </svg>
  );
};

export default TelegramSVG;
